import { Box, useTheme } from '@mui/material';
import { EquityStockScanner } from 'components/stock_scanner/EquityStockScanner';

interface StockScannerProps {
  stockDetailsFullscreen: boolean;
  setStockDetailsFullscreen: (fullscreen: boolean) => void;
}

export const StockScanner = ({
  stockDetailsFullscreen,
  setStockDetailsFullscreen,
}: StockScannerProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        transition: '0.5s',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: stockDetailsFullscreen ? '100%' : '600px',
        borderRadius: theme.spacing(3),
        paddingBottom: '35px',
        paddingLeft: 4,
        paddingTop: 2,
      }}
    >
      <EquityStockScanner
        stockDetailsFullscreen={stockDetailsFullscreen}
        setStockDetailsFullscreen={setStockDetailsFullscreen}
      />
    </Box>
  );
};
